import React, { useState } from "react";
import { jsPDF } from "jspdf";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

const ImageToPdfConverter = () => {
  const [images, setImages] = useState([]);

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const imageFiles = files.map((file) => ({
      file,
      url: URL.createObjectURL(file),
    }));
    setImages((prev) => [...prev, ...imageFiles]);
  };

  const removeImage = (indexToRemove) => {
    const updatedImages = images.filter((_, index) => index !== indexToRemove);
    setImages(updatedImages);
  };

  const generatePDF = async () => {
    if (!images.length) return;
    const pdf = new jsPDF();

    for (let i = 0; i < images.length; i++) {
      const img = new Image();
      img.src = images[i].url;

      await new Promise((resolve) => {
        img.onload = () => {
          const imgWidth = pdf.internal.pageSize.getWidth();
          const imgHeight = (img.height * imgWidth) / img.width;

          if (i > 0) pdf.addPage();
          pdf.addImage(img, "PNG", 0, 0, imgWidth, imgHeight);
          resolve();
        };
      });
    }

    pdf.save("merged-images.pdf");
  };

  return (
    <>
      <Helmet>
        <title>Multiple Image to Single PDF Converter - Free Tool</title>
        <meta
          name="description"
          content="Free online tool to convert multiple images into a single PDF. Upload JPG, PNG, or SVG images and download a combined PDF. No backend or API needed!"
        />
        <meta
          name="keywords"
          content="multiple image to pdf, image to pdf converter, merge images pdf, jpg to pdf, png to pdf, frontend pdf tool"
        />
        <link rel="canonical" href="https://freelity.com/image-to-pdf" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2 className="mb-4">Multiple Image to One PDF Converter</h2>
          <p>Free Online Image to PDF Converter — JPG, PNG to PDF, Upload multiple images JPG, PNG, SVG, etc.</p>
          <div className="mb-3">
            <input
              type="file"
              className="form-control"
              multiple
              accept="image/*"
              onChange={handleImageUpload}
            />
          </div>

          {images.length > 0 && (
            <>
              <div className="row mb-3">
                {images.map((img, index) => (
                  <div className="col-md-3 mb-3" key={index}>
                    <div className="position-relative border p-2">
                      <img
                        src={img.url}
                        alt={`Preview ${index}`}
                        className="img-fluid mb-2"
                      />
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => removeImage(index)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <button className="btn btn-success" onClick={generatePDF}>
                Convert to PDF
              </button>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default ImageToPdfConverter;
